import { useEffect, useState } from "react";
import {
  Box,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  useTheme,
} from "@mui/material";
import { CaretDownIcon, LiveIcon } from "~components/Icons";
import { getStyles } from "./styles";
import { usePollContext } from "~contexts/Poll";
import { IPoll } from "~contexts/Socket/interfaces";
import { useToastNotificationContext } from "~contexts/ToastNotification";

const PollQuestion = () => {
  const theme: any = useTheme();
  const [orderedPolls, setOrderedPolls] = useState<IPoll[]>([]);
  const { polls, onRefreshPolls, onFinishPoll, setPollActive } = usePollContext();
  const { setToastData } = useToastNotificationContext();
  const { styles } = getStyles(theme);

  useEffect(() => {
    const sortedPolls = polls.sort((a, b) => {
      if (!Object.hasOwn(b, "active")) return -1;
      return Number(b.active) - Number(a.active);
    });

    setOrderedPolls(sortedPolls);
  }, [polls]);

  if (!polls) return <>carregando...</>;

  return (
    <Box sx={{ mt: 10 }}>
      {orderedPolls.map((poll) => {
        const answersCount = poll.options.reduce((acc, option) => acc + option.count, 0);
        const icon = poll.active ? <LiveIcon style={{ margin: "1px 0 0 3px" }} /> : <></>;

        return (
          <Accordion sx={{ "&:before": { display: "none" } }} key={poll.id} square>
            <AccordionSummary sx={{ padding: "0" }} expandIcon={<CaretDownIcon />}>
              <Typography style={styles.title}>{poll.question}</Typography>
              {Object.hasOwn(poll, "active") && (
                <Chip
                  color={poll.active ? "success" : "error"}
                  label={poll.active ? "enquete ativa" : "enquete encerrada"}
                  icon={icon}
                  variant="status"
                  sx={{ ml: 1 }}
                />
              )}
            </AccordionSummary>
            <AccordionDetails sx={{ padding: "0" }}>
              <Typography>@{poll.question}</Typography>
              <Typography>{answersCount} respostas - até o momento</Typography>
              <Box>
                {poll.options.map((answer) => (
                  <div key={answer.id} style={styles.answers}>
                    {answer.image && (
                      <img style={styles.image} src={answer.image} alt={answer.text} />
                    )}

                    <div style={{ display: "flex" }}>
                      <div style={{ color: "#fff" }}>{answer.text}</div>
                      <div style={{ margin: "0 10px" }}>
                        {answer.porcentQuestion}% dos votos
                      </div>
                      <div>{answer.count} votos</div>
                    </div>
                  </div>
                ))}
              </Box>

              <Box style={styles.buttons}>
                <Button
                  disableRipple
                  disableFocusRipple
                  sx={styles.button}
                  disabled={!!poll.active}
                  onClick={() => setPollActive(poll.id)}
                >
                  ativar enquete
                </Button>
                <Button
                  style={styles.refreshButton}
                  disableFocusRipple
                  disableRipple
                  onClick={() => {
                    setToastData({title: '', text: 'resultados atualizados' }, 'success')
                    onRefreshPolls();
                  }}
                >
                  atualizar resultados
                </Button>
                <Button
                  disableFocusRipple
                  disableRipple
                  onClick={() => onFinishPoll(poll.id)}
                >
                  finalizar enquete
                </Button>
              </Box>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Box>
  );
};

export default PollQuestion;
